module.exports = __webpack_public_path__ + "static/media/EG.e1ba2666.svg";